module.exports = __webpack_public_path__ + "static/ideas-27b1b06134e7fedadb3964b131a72868.svg";